import { gql } from '@parkchirp/api-client';

export const LIST_INVOICES = gql`
  query listInvoices(
    $limit: Int
    $offset: Int
    $order: Order
    $filters: [Filter]
    $facility_id: String
    $special: Special
  ) {
    listInvoices(
      limit: $limit
      offset: $offset
      order: $order
      filters: $filters
      facility_id: $facility_id
      special: $special
    ) {
      total
      limit
      offset
      invoices {
        id
        readable_id
        amount
        balance
        type
        due_on
        parking_period_year
        parking_period_month
        mailInvoice
        created_at
        billing_date
        payor {
          id
          readable_id
          billing_firstname
          billing_lastname
          info_name
          cognito_sub
        }
        subscription {
          subscription_name
          account_id
          billing_profile_id
          billing_profile {
            id
            name
            facility_id
            facility {
              facility_number
              facility_name
              timezone
            }
          }
        }
      }
    }
  }
`;

export const GET_INVOICES_FROM_CACHE_CSV = gql`
query getInvoicesFromCacheCsv(
  $limit: Int!
  $offset: Int!
  $filters: [Filter]
  $order: SortOrder
  $facilityId: String
  $getDrafts: Boolean
) {
  getInvoicesFromCacheCsv(
    limit: $limit
    offset: $offset
    filters: $filters
    order: $order
    facilityId: $facilityId
    getDrafts: $getDrafts
  ) {
    url
  }
}
`;

export const LIST_INVOICES_FROM_CACHE = gql`
  query listInvoicesFromCache(
    $limit: Int!
    $offset: Int!
    $filters: [Filter]
    $order: SortOrder
    $facilityId: String
    $getDrafts: Boolean
  ) {
    listInvoicesFromCache(
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
      facilityId: $facilityId
      getDrafts: $getDrafts
    ) {
      count
      invoices {
        id
        invoiceNumber
        facilityId
        facilityNumber
        facilityName
        invoiceDate
        invoiceLocalDate
        parkingPeriodMonth
        parkingPeriodYear
        dueDate
        invoiceType
        accountId
        subscriberId
        subscriptionName
        amount
        balance
      }
    }
  }
`;

export const LIST_INVOICES_FOR_INVOICE_PAGE = gql`
  query listInvoicesForInvoicePage(
    $limit: Int!
    $offset: Int!
    $filters: [Filter]
    $order: SortOrder
    $facilityId: String
    $getDrafts: Boolean
  ) {
    listInvoicesForInvoicePage(
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
      facilityId: $facilityId
      getDrafts: $getDrafts
    ) {
      count
      invoices {
        id
        invoiceNumber
        facilityId
        facilityNumber
        facilityName
        invoiceDate
        invoiceLocalDate
        parkingPeriod
        parkingPeriodMonth
        parkingPeriodYear
        dueDate
        invoiceType
        accountId
        subscriberId
        subscriptionName
        amount
        balance
        isAutoLateFeeInvoice
      }
    }
  }
`;

export const LIST_INVOICES_V2 = gql`
  query listInvoices(
    $limit: Int!
    $offset: Int!
    $filters: [Filter]
    $order: SortOrder
    $facilityId: String
  ) {
    listInvoices(
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
      facilityId: $facilityId
    ) {
      count
      invoices {
        id
        invoiceNumber
        facilityId
        facilityNumber
        facilityName
        invoiceDate
        parkingPeriodMonth
        parkingPeriodYear
        dueDate
        invoiceType
        accountId
        subscriberId
        subscriptionName
        amount
        balance
      }
    }
  }
`;

export const GET_INVOICES_CSV = gql`
  query getInvoicesCSV(
    $filters: [Filter]
    $order: SortOrder
    $facilityId: String
  ) {
    getInvoicesCSV(
      filters: $filters
      order: $order
      facilityId: $facilityId
    ) {
        url
    }
  }
`;

export const GET_INVOICE_DETAILS = gql`
    query getInvoiceDetails(
        $invoiceId: String!
    ) {
        getInvoiceDetails(invoiceId: $invoiceId) {
            id
            dueOn
            createdAt
            type
            parkingPeriodMonth
            parkingPeriodYear
            amount
            balance
            notes
            readableId
            detailNotes
            accountId
            subscriptionName
            facilityName
            facilityNumber
            facilityTimezone
            facilityId
            payorAccountId
            isDraft
            billingDate
            createdByDailyReport
            subscriptionId
        }
    }
`;

export const GET_INVOICE_LINE_ITEMS = gql`
    query getInvoiceLineItems(
        $invoiceId: String!
    ) {
        getInvoiceLineItems(invoiceId: $invoiceId) {
            id
            parker {
                id
                first_name
                last_name          
                selected_end_date
                selected_start_date
            }
            sublot {
                name
                id
            }
            fee {
                type
                price
                tax1
                tax2
                tax3
                tax4
                name
            }
            rate {
                name
            }
            amount
            serviceDateEnd
            serviceDateStart
            balance
            dailyReport {
                id
                readableId
            }
        }
    }
`;

export const GET_INVOICE_PDF = gql`
  query getInvoicePDF($invoiceId: String!, $invoiceType: String!, $facilityId: String!) {
        getInvoicePDF(invoiceId: $invoiceId, invoiceType: $invoiceType, facilityId: $facilityId) {
          pdfUrl
        }
    }`;

export const GET_INVOICE_LINE_ITEMS_CSV = gql`
query getInvoiceLineItemsCSV($invoiceId: String!) {
    getInvoiceLineItemsCSV(invoiceId: $invoiceId) {
      url
    }
}
`;

export const GET_INVOICE_HISTORY_CSV = gql`
query getInvoiceHistoryCSV($historyData: [HistoryData]!) {
    getInvoiceHistoryCSV(historyData: $historyData) {
      url
    }
}
`;

export const UPDATE_INVOICE_DETAIL_NOTES = gql`
    mutation updateInvoiceDetailNotes(
        $invoiceId: ID!
        $notes: String
    ) {
        updateInvoiceDetailNotes(
            invoiceId: $invoiceId
            notes: $notes
        )
    }
`;

export const UPDATE_INVOICE_NOTES = gql`
    mutation updateInvoiceNotes(
        $invoiceId: ID!
        $notes: String
    ) {
        updateInvoiceNotes(
            invoiceId: $invoiceId
            notes: $notes
        )
    }
`;

export const GET_INVOICE_LINE_ITEM_ENTRY_AMOUNTS_BY_INVOICE_ID = gql`
    query getInvoiceLineItemEntryAmountsByInvoiceId(
        $invoiceId: String!
    ) {
        getInvoiceLineItemEntryAmountsByInvoiceId(invoiceId: $invoiceId) {
            amount
            amountTax1
            amountTax2
            amountTax3
            amountTax4
            grossAmount
        }
    }
`;

export const GET_INVOICE_LINE_ITEM_ENTRIES = gql`
    query getInvoiceLineItemEntries(
        $lineItemId: String!
    ) {
        getInvoiceLineItemEntries(lineItemId: $lineItemId) {
            id
            type
            amount
            amountTax1
            amountTax2
            amountTax3
            amountTax4
            createdAt
            applicationDate
            creditApplicationType
        }
    }
`;

export const AMOUNT_ADJUSTMENT_INVOICE_ACTION = gql`
    mutation amountAdjustmentInvoiceAction(
        $invoiceId: String!
        $adjustmentType: InvoiceAdjustmentTypeEnum!
        $adjustment: AmountAdjustmentInput!
        $adjustmentAction: InvoiceAdjustmentActionTypeEnum!
    ) {
        amountAdjustmentInvoiceAction(
            invoiceId: $invoiceId
            adjustmentType: $adjustmentType
            adjustment: $adjustment
            adjustmentAction: $adjustmentAction
        ) {
            id
        }
    }
`;

export const MANUAL_ADJUSTMENT_INVOICE_ACTION = gql`
    mutation manualAdjustmentInvoiceAction(
        $invoiceId: String!
        $adjustments: [InvoiceManualAdjustmentInput]!
    ) {
        manualAdjustmentInvoiceAction(
            invoiceId: $invoiceId
            adjustments: $adjustments
        ) {
            id
        }
    }
`;

export const UPDATE_NOTES_INVOICE_HISTORY = gql`
    mutation updateNotesInvoiceHistory(
        $referenceId: String!
        $type: InvoiceHistoryRowTypeEnum!
        $notes: String
    ) {
        updateNotesInvoiceHistory(
            referenceId: $referenceId
            type: $type
            notes: $notes
        )
    }
`;

export const LIST_REVERSALS_INVOICE_HISTORY = gql`
    query listReversalsInvoiceHistory(
        $invoiceId: String!
    ) {
        listReversalsInvoiceHistory(invoiceId: $invoiceId) {
            id
            notes
            rowType
            amount
            createdAt
            displayAmount
            invoiceId
            paymentId
            paymentGroupId
            applicationDate
            applicationType
            creditId
            creditNumber
            creditAmount
            creditDisplayAmount
        }
    }
`;

export const LIST_CREDITS_INVOICE_HISTORY = gql`
    query listCreditsInvoiceHistory(
        $invoiceId: String!
    ) {
        listCreditsInvoiceHistory(invoiceId: $invoiceId) {
            id
            notes
            rowType
            amount
            createdAt
            displayAmount
            invoiceId
            paymentId
            applicationDate
            applicationType
            creditId
            creditNumber
            creditAmount
            creditDisplayAmount
        }
    }
`;

export const LIST_ADJUSTMENTS_INVOICE_HISTORY = gql`
    query listAdjustmentsInvoiceHistory(
        $invoiceId: String!
    ) {
        listAdjustmentsInvoiceHistory(invoiceId: $invoiceId) {
            id
            notes
            rowType
            amount
            createdAt
            displayAmount
            invoiceId
            paymentId
            applicationDate
            applicationType
            creditId
            creditNumber
            creditAmount
            creditDisplayAmount
            paymentBatch
			paymentBatchType
        }
    }
`;

export const LIST_REFUND_INVOICE_HISTORY = gql`
    query listRefundsInvoiceHistory(
        $invoiceId: String!
    ) {
        listRefundsInvoiceHistory(invoiceId: $invoiceId) {
            id
            notes
            rowType
            amount
            createdAt
            applicationType
            displayAmount
            paymentId
            paymentGroupId
            applicationDate
        }
    }
`;

export const LIST_PAYMENTS_INVOICE_HISTORY = gql`
    query listPaymentsInvoiceHistory(
        $invoiceId: String!
    ) {
        listPaymentsInvoiceHistory(invoiceId: $invoiceId) {
            id
            notes
            rowType
            amount
            createdAt
            displayAmount
            invoiceId
            paymentId
            paymentGroupId
            applicationDate
            applicationType
            creditId
            creditNumber
            creditAmount
            creditDisplayAmount
            paymentBatch
			paymentBatchType
        }
    }
`;
